<template>
  <el-menu-item
    v-if="meta.isRoot"
    :index="data.path">
    <SvgIcon 
      v-if="meta.icon"
      :icon-class="meta.icon"/>
    <template 
      slot="title">
      {{ meta.title }}
    </template>
  </el-menu-item>
  <el-submenu
    v-else
    :index="data.path">
    <template 
      slot="title">
      <SvgIcon 
        v-if="meta.icon"
        :icon-class="meta.icon"/>
      <span>{{ meta.title }}</span>
    </template>
    <Item
      v-for="item in children"
      :key="item.name"
      :data="item"/>
  </el-submenu>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue'
export default {
  name: 'Item',
  props: {
    data: Object
  },
  computed: {
    meta(){
      return this.data.meta || {}
    },
    children(){
      return this.data.children || []
    }
  },
  components: {
    SvgIcon
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/Sidebar/Menu/Item.vue